import { AutogenLayoutSettlementHistory } from "./autogen/AutogenLayoutSettlementHistory";
import {
    AddType,
    ClickEvent,
    Component,
    DataSource,
    DataSourceMode,
    DataSourceModeChangeEvent,
    Label,
    OpenType,
    Panel,
    SelectionMode, Snackbar,
    Tab,
    TableRow,
    TableRowBeforeSaveEvent,
    Tabset, Toast
} from "@mcleod/components";
import { UsersResponsibilitySlideoutTrans } from "@mcleod/general";
import { OrderPostHist, OrderPostHistProps } from "@mcleod/dispatch";
import { ImageTable } from "@mcleod/common";
import {Api, HorizontalAlignment, ModelRow, StringUtil} from "@mcleod/core";
import { MovementUsers } from "@mcleod/dispatch/src/MovementUsers";
import {TriumphPayTxDetail} from "./TriumphPayTxDetail";

export class SettlementHistory extends AutogenLayoutSettlementHistory {

    async onLoad(): Promise<void> {
        this.layoutSettlement.replaceMainDatasource(this.sourceDrsSettleHist);
        this.rebindDataSource(this.layoutSettlement.sourceDrsPendingDeduct, this.sourceDrsDeductHist);
        this.rebindDataSource(this.layoutSettlement.sourceJournalDriver, this.sourceJournalDriver);
        this.rebindDataSource(this.layoutSettlement.sourceComments, this.sourceComments);

        this.sourceDrsSettleHist.addAfterModeChangeListener((event: DataSourceModeChangeEvent) => {
            this.dataheaderSettlementHistory.showExecute = event.newMode === DataSourceMode.SEARCH;
            if (event.newMode !== DataSourceMode.SEARCH) {
                this.disableFields();
                this.buttonResponsibility.visible = true;
                this.buttonOrderHistory.visible = true;
                this.setTitle();
                this.layoutSettlement.layoutBackOfficeCommentsTable.tableComments.addRowBeforeSaveListener((event: TableRowBeforeSaveEvent) => {
                    const commentRow = event.getTableRow().data as ModelRow;
                    commentRow.set("parent_row_id", this.mainDataSource.activeRow.get("id"));
                    commentRow.set("parent_row_type", "H");
                });
            }
        });
        this.layoutSettlement.tableDeductions.customFilter = (row: TableRow) => {
            return row.data.get("check_number") === this.activeRow?.get("check_number");
        };
        this.mainDataSource.addAfterSearchPlusChildrenListener(async () => {
            this.layoutSettlement.calculateUnits(this.activeRow.get("pay_method"), false);
            await this.layoutSettlement.calculatePayTotals(null, false, this.layoutSettlement.tableDeductions.rows.map(row => row.data)); // make sure all datasources are done searching before calculating totals
        });
        this.layoutSettlement.textboxVoidDate.visible = true;
        this.layoutSettlement.checkboxIsVoid.visible = true;
        this.layoutSettlement.checkboxAllocated.visible = true;
        this.layoutSettlement.textboxCheckDate.visible = true;
        this.layoutSettlement.textboxOrderTotDist.visible = false;
        this.layoutSettlement.textboxProcessStatus.visible = false;
        this.layoutSettlement.textboxReasonCode.visible = false;
        this.layoutSettlement.textboxReasonCodeComment.visible = false;
        this.layoutSettlement.textboxReadyToPayFlag.visible = false;
        this.layoutSettlement.textboxOk2payDate.rowBreak = false;
        this.layoutSettlement.checkboxLoaded.visible = false;
        this.layoutSettlement.checkboxLoadedHistory.visible = true;
        this.layoutSettlement.layoutBackOfficeCommentsTable.tableComments.allowDelete = false;
        this.layoutSettlement.layoutBackOfficeCommentsTable.tableComments.persistChangesImmediately = true;
        this.layoutSettlement.tableDeductions.displayToolsCell = false;
        this.layoutSettlement.tableDeductions.selectionMode = SelectionMode.SINGLE;
        this.layoutSettlement.tableDeductions.detailLayout = "lme/settlement/PayAdjustmentHistory";
        this.layoutSettlement.tableDeductions.allowDetail = true;
        this.layoutSettlement.tableDeductions.crudManager.defaultOpenType = OpenType.NEW_TAB_WITH_SWITCH;
        this.layoutSettlement.tableDeductions.allowEdit = false;
        this.layoutSettlement.tableDeductions.removeColumn("Hold Reason");
        this.layoutSettlement.tableDeductions.removeColumn("Hold Reason Comment");
        this.layoutSettlement.tableDeductions.removeColumn("Status");

    }

    async sourceDrsSettleHistAfterExecution(event: DataSourceModeChangeEvent) {
       if(!StringUtil.isEmptyString(this.mainDataSource.activeRow.get("triumphpay_pymt_id"))
           && !StringUtil.isEmptyString(this.mainDataSource.activeRow.get("triumphpay_invoice_key"))) {
           if (await TriumphPayTxDetail.isPayeeTriumphPay(this.mainDataSource.activeRow.get("payee_id"))) {
               this.layoutSettlement.layoutTriumphPayTxDetail.textboxTriumphpayInvoiceStatus.visible = false;
                this.layoutSettlement.layoutTriumphPayTxDetail.checkboxTriumphpayQuickpay.visible = false;

               const response = await Api.post("lme/settlement/get-payment-details", {id: this.mainDataSource.activeRow.get("id")});
               if (response?.data?.[0]?.updated) {
                   const triumphPayData = response?.data?.[0];

                   if (triumphPayData.triumphpay_transaction_num) {
                       this.layoutSettlement.layoutTriumphPayTxDetail.textboxTriumphpayTransactionNum.text = triumphPayData.triumphpay_transaction_num;
                   }
                   if (triumphPayData.triumphpay_pymt_status) {
                       this.layoutSettlement.layoutTriumphPayTxDetail.textboxTriumphpayPymtStatus.text = triumphPayData.triumphpay_pymt_status;
                   }
                   if (triumphPayData.triumphpay_transaction_date) {
                       this.layoutSettlement.layoutTriumphPayTxDetail.textboxTriumphpayTransactionDate.text = triumphPayData.triumphpay_transaction_date;
                   }
                   if (triumphPayData.triumphpay_carrierpay_date) {
                       this.layoutSettlement.layoutTriumphPayTxDetail.textboxTriumphpayCarrierpayDate.text = triumphPayData.triumphpay_carrierpay_date;
                   }
                   if (triumphPayData.triumphpay_confirm_code) {
                       this.layoutSettlement.layoutTriumphPayTxDetail.textboxTriumphpayConfirmCode.text = triumphPayData.triumphpay_confirm_code;
                   }
                   if (triumphPayData.triumphpay_pymt_details) {
                       this.layoutSettlement.layoutTriumphPayTxDetail.textboxTriumphpayPymtDetails.text = triumphPayData.triumphpay_pymt_details;
                   }

                   this.layoutSettlement.layoutTriumphPayTxDetail.checkboxTriumphpayQuickpay.checked = triumphPayData.triumphpay_quickpay;
                   await this.showTriumphPaySuccessToast(triumphPayData.response_message);

               } else {
                   Snackbar.showSnackbar(response?.data?.[0].response_message || "Failed to retrieve TriumphPay payment details.");
               }
           }else{
               this.layoutSettlement.layoutTriumphPayTxDetail.visible = false;
           }
       }

    }

    private async showTriumphPaySuccessToast(response_message: any) {
        const panelContainer = new Panel({ align: HorizontalAlignment.CENTER });
        const headerMessage = new Label({
            text: "Success!",
            fontSize: "large",
            rowBreak: true,
            align: HorizontalAlignment.CENTER
        });
        const message = response_message || `Payment details have been successfully updated.`;
        const successMessage = new Label({
            text: message,
            rowBreak: true,
            align: HorizontalAlignment.CENTER
        });
        panelContainer.add(headerMessage);
        panelContainer.add(successMessage);

        Toast.showToast(panelContainer, { backgroundColor: "success" }, {
            millisUntilDismissal: 7000
        });
    }

    rebindDataSource(oldDatasource: DataSource, newDatasource: DataSource) {
        if (newDatasource != null) {
            oldDatasource.rebindComponentsTo(newDatasource);
            newDatasource.attachListeners(oldDatasource);
            oldDatasource = newDatasource;
            this[oldDatasource.id] = newDatasource;
        }
    }

    private disableFields() {
        this.layoutSettlement.tabsetSettlement.tabs.forEach((tab: Tab) => {
            if (tab.id !== "tabStopDetails" && tab.id !== "tabImages" && tab.id !== "tabComments") {
                tab.forEveryChildComponent((component: Component) => {
                    if (component instanceof Tabset || component instanceof Label) {
                        return;
                    }
                    component.enabled = false;
                });
            }
        });
        (this.layoutSettlement.layoutImageTable as ImageTable).buttonUploadImage.enabled = false;
        this.layoutSettlement.tableDeductions.addType = AddType.NOT_ALLOWED;

    }

    buttonResponsibilityOnClick(event: ClickEvent): void {
        const urs = new UsersResponsibilitySlideoutTrans("lme/dispatch/MovementUsers", "Movement Users - " + this.activeRow.get("movement_id"), { id: this.activeRow.get("movement_id") }, [], this.sourceDrsSettleHist, this.layoutSettlement.sourceResponsibleHist);
        const responsibleHistLayout = urs.layout as MovementUsers;
        responsibleHistLayout.addLayoutLoadListener(() => {
            responsibleHistLayout.textboxDispatcherUserId.visible = false;
            responsibleHistLayout.textboxFleetManager.visible = false;
            responsibleHistLayout.textboxOperationsUser.visible = false;
            responsibleHistLayout.layoutResponsibleHist.tableResponsibleHist.addType = AddType.NOT_ALLOWED;
            responsibleHistLayout.layoutResponsibleHist.tableResponsibleHist.allowEdit = false;
            responsibleHistLayout.layoutResponsibleHist.tableResponsibleHist.allowDelete = false;
            urs.includeCommissions = true;
        });
        urs.show();
    }

    buttonOrderHistoryOnClick(event: ClickEvent): void {
        const props: OrderPostHistProps = {
            orderType: "ORDER",
            orderId: this.activeRow.get("order_id"),
            movementId: this.activeRow.get("movement_id"),
            isBilled: true
        };
        OrderPostHist.showInSlideout(
            props, DataSourceMode.UPDATE, this.buttonOrderHistory);
    }

    protected setTitle() {
        if (this.mainDataSource.mode === DataSourceMode.ADD || this.mainDataSource.mode === DataSourceMode.SEARCH) {
            return;
        }
        const orderId = this.mainDataSource.activeRow?.get("order_id");
        const payeeData = this.mainDataSource.activeRow?.getLookupModelData("payee_id");
        const payee = payeeData && payeeData[0] ? " - " + payeeData[0].get("name") : "";
        const titleSuffix = StringUtil.isEmptyString(orderId) ? payee : " - " + orderId + payee;
        this.dataHeader.title = this.titleSingular + titleSuffix;
    }
}
